import script from "./project-life-report.vue?vue&type=script&lang=ts&setup=true"
export * from "./project-life-report.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__